import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styled from 'styled-components';
import styles from '../../../styles';

const OverflowFixer = styled.div`
  position: fixed;
  z-index: 1001;
  width: 100vw;
`;

const StyledHamburger = styled.a`
  position: absolute;
  width: 4.5rem;
  height: 4.5rem;
  top: 2.5rem;
  right: 3.75rem;

  ${styles.media.tablet`
    width: 6rem;
    height: 6rem;
  `}
  
  ${styles.media.phone`
    width: 4.5rem;
    height: 4.5rem;
    top: 1.875rem;
    right: 1.875rem;
  `}
  background-color: ${styles.color.ORANGE};
  border-radius: 100%;
  z-index: 1001;
  box-shadow: rgba(59, 60, 67, 0.2) 0px 0.625rem 1.5rem;

  transition-property: box-shadow, background-color;
  transition-duration: 0.25s;
  transition-timing-function: ${styles.easing.inOutQuad};
  cursor: pointer;

  .current-input-mouse &:hover,
  .current-input-touch &:active {
    background-color: ${styles.color.SLATE};
    box-shadow: rgba(59, 60, 67, 0.2) 0px 1.25rem 3rem;
  }

  svg {
    position: absolute;
    top: 0;
    left: 0;
    color: white;

    fill: currentColor;
    transform-origin: 50% 50%;
    transition: transform 0.35s ${styles.easing.inOutBack};

    &.top {
      transform: translate3d(0, -0.4375rem, 0) rotate(0deg);
    }
    &.mid {
      transform: translate3d(0, 0, 0) scale(1, 1);
    }
    &.bot {
      transform: translate3d(0, 0.4375rem, 0) rotate(0deg);
    }
  }

  &.open {
    svg {
      &.top {
        transform: translate3d(0, 0, 0) rotate(45deg);
      }
      &.mid {
        transform: translate3d(0, 0, 0) scale(0, 1);
      }
      &.bot {
        transform: translate3d(0, 0, 0) rotate(-45deg);
      }
    }
  }
`;

const Hamburger = props => {
  const { isOpen, onClick } = props;
  const className = classnames({
    open: isOpen,
  });
  return (
    <OverflowFixer>
      <StyledHamburger onClick={onClick} className={className}>
        <svg viewBox="0 0 72 72" className="top">
          <rect x="21" y="35" width="30" height="2" />
        </svg>
        <svg viewBox="0 0 72 72" className="mid">
          <rect x="21" y="35" width="30" height="2" />
        </svg>
        <svg viewBox="0 0 72 72" className="bot">
          <rect x="21" y="35" width="30" height="2" />
        </svg>
      </StyledHamburger>
    </OverflowFixer>
  );
};

Hamburger.propTypes = {
  onClick: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
};

export default Hamburger;



// WEBPACK FOOTER //
// ./src/modules/navigation/components/Hamburger.js